module.exports = __webpack_public_path__ + "static/media/nn_skrivhastighet_video.d6e68428.mp4";